<!--
 * @description: components
 * @author: 06455
 * @date: 2023/12/13 10:18
-->
<template>
  <lsSearchForm
    ref="searchForm"
    @search="handleSearch"
    :initExpand="false"
    :formList="formList"
    @reset="reset"
    :auto-clear="true"
  >
    <ls-select
      slot="completeStatus"
      v-decorator="['completeStatus']"
      :showSearch="true"
      placeholder="请选择"
      :options="COMPLETE_STATUS_LIST"
      :filter-option="filterOption"
      allowClear
    />
    <!-- 单据状态在已审核、全部、显示增货单才显示 -->
    <ls-select
      slot="status"
      v-model="formData.status"
      :showSearch="true"
      placeholder="请选择"
      :options="SEARCH_STATUS_LIST"
      :filter-option="filterOption"
      allowClear
    />
    <ls-select
      slot="dischargeIs"
      v-decorator="['dischargeIs']"
      :showSearch="true"
      placeholder="请选择"
      :options="TRUE_IS"
      :filter-option="filterOption"
      allowClear
    />
    <ls-select
      slot="internalExclusiveIs"
      v-decorator="['internalExclusiveIs']"
      :showSearch="true"
      placeholder="请选择"
      :options="INNER_OUT"
      :filter-option="filterOption"
      allowClear
    />
    <ls-select
      slot="supplierExclusiveIs"
      v-decorator="['supplierExclusiveIs']"
      :showSearch="true"
      placeholder="请选择"
      :options="FACTORY_IS"
      :filter-option="filterOption"
      allowClear
    />
    <ls-select
      slot="warehouseCode"
      v-decorator="['warehouseCodeList']"
      :showSearch="true"
      placeholder="请选择"
      mode="multiple"
      :options="selectWarehouseList"
      :filter-option="filterOption"
      allowClear
    />
    <a-row slot="supplierPriorityLevel">
      <a-col :span="11">
        <a-input-number v-decorator="['supplierPriorityLevelStart']" placeholder="开始值" style="width: 100%" />
      </a-col>
      <a-col :span="2" style="text-align: center">
        ~
      </a-col>
      <a-col :span="11">
        <a-input-number v-decorator="['supplierPriorityLevelEnd']" placeholder="结束值" style="width: 100%" />
      </a-col>
    </a-row>
    <a-row slot="unArrangeQuantity">
      <a-col :span="12">
        <ls-select
          v-model="formData.unArrangeQuantity.type"
          :showSearch="true"
          placeholder="请选择"
          :options="RANGE_LIST"
          :filter-option="filterOption"
        />
      </a-col>
      <a-col :span="12">
        <a-input-number v-model="formData.unArrangeQuantity.value" style="width: 100%" />
      </a-col>
    </a-row>
    <template #supplierPriorityLevelTitle>
      <span
      >供应商入...&nbsp;
        <a-tooltip title="供应商入库优先级">
          <a-icon type="question-circle-o" />
        </a-tooltip>
      </span>
    </template>
    <template #internalExclusiveIsTitle>
      <span
      >是否独占...
        <a-tooltip title="是否独占（内外部）">
          <a-icon type="question-circle-o" />
        </a-tooltip>
      </span>
    </template>
    <template #supplierExclusiveIsTitle>
      <span
      >是否独占...
        <a-tooltip title="是否独占（单工厂）">
          <a-icon type="question-circle-o" />
        </a-tooltip>
      </span>
    </template>

    <a-range-picker
      slot="requireDeliveryDay"
      v-decorator="[`requireDeliveryDay`]"
      style="width: 100%"
      :placeholder="['开始日期', '结束日期']"
    />
    <lsSelectPage
      slot="dispatcherNo"
      v-decorator="['dispatcherNo']"
      :datas="dispatcherList"
      searchKey="dispatcher"
      valueKey="jobNo"
      placeholder="请选择"
    >
      <template slot="select-option" slot-scope="{items}">
        <a-select-option v-for="(i, index) in items" :key="index" :value="i.jobNo" :title="i.realName">
          {{ `${i.jobNo}-${i.realName}` }}
        </a-select-option>
      </template>
    </lsSelectPage>
    <ls-select
      slot="earlyMorningDeliveryIs"
      v-decorator="['earlyMorningDeliveryIs']"
      :showSearch="true"
      placeholder="请选择"
      :options="MORNING_OR_EVENING_LIST"
      :filter-option="filterOption"
      allowClear
    />
    <ls-select
      slot="momAutoCreateIs"
      v-decorator="['momAutoCreateIs']"
      :showSearch="true"
      placeholder="请选择"
      :options="CREATE_IS_LIST"
      :filter-option="filterOption"
      allowClear
    />
    <a-range-picker
      slot="dataCreateTime"
      v-decorator="[`dataCreateTime`]"
      style="width: 100%"
      :placeholder="['开始日期', '结束日期']"
    />
  </lsSearchForm>
</template>

<script>
import {
  TRUE_IS,
  COMPLETE_STATUS_LIST,
  INNER_OUT,
  RANGE_LIST,
  SEARCH_STATUS_LIST,
  FACTORY_IS,
  MORNING_OR_EVENING_LIST,
  MORNING_OR_EVENING, CREATE_IS_LIST
} from '../enum'
import { apiGetDispatchList } from '@/services/module/receiving-plan'
export default {
  name: 'SearchInput',
  props: {
    status: {
      type: Number,
      default: 10
    }
  },
  inject: ['warehouseList'],
  computed: {
    selectWarehouseList () {
      return this.warehouseList?.()
    }
  },
  data () {
    return {
      MORNING_OR_EVENING,
      MORNING_OR_EVENING_LIST,
      CREATE_IS_LIST,
      TRUE_IS,
      COMPLETE_STATUS_LIST,
      INNER_OUT,
      RANGE_LIST,
      SEARCH_STATUS_LIST,
      FACTORY_IS,
      formList: [
        {
          label: '供应商',
          type: 'input',
          decorator: ['factoryName'],
          attrs: {
            placeholder: '请输入'
          }
        },
        {
          label: '物料编码',
          type: 'input',
          decorator: ['materialNo'],
          attrs: {
            placeholder: '请输入'
          }
        },
        {
          label: '要求到货日期',
          type: 'requireDeliveryDay'
        },
        {
          label: '未安排数量',
          type: 'unArrangeQuantity'
        },
        {
          label: '入库仓库',
          type: 'warehouseCode'
        },
        {
          label: '增货计划单',
          type: 'input',
          decorator: ['parentBillNo'],
          attrs: {
            placeholder: '请输入'
          }
        },
        {
          label: '计划单号',
          type: 'input',
          decorator: ['billNo'],
          attrs: {
            placeholder: '请输入'
          }
        },
        {
          label: '增货-送货单',
          type: 'input',
          decorator: ['parentReceiptBillNo'],
          attrs: {
            placeholder: '请输入'
          }
        },
        // {
        //   label: '单据状态',
        //   type: 'status'
        // },
        {
          label: '完成状态',
          type: 'completeStatus'
        },
        {
          label: '供应商入库优先级',
          labelSlot: 'supplierPriorityLevelTitle',
          type: 'supplierPriorityLevel'
        },
        {
          label: '存放区域',
          type: 'input',
          decorator: ['depositAreaName'],
          attrs: {
            placeholder: '请输入'
          }
        },
        {
          label: '独占内外部',
          labelSlot: 'internalExclusiveIsTitle',
          type: 'internalExclusiveIs'
        },
        {
          label: '独占单工厂',
          labelSlot: 'supplierExclusiveIsTitle',
          type: 'supplierExclusiveIs'
        },
        {
          label: '供应商仓库',
          type: 'input',
          decorator: ['factoryWarehouseName'],
          attrs: {
            placeholder: '请输入'
          }
        },
        {
          label: '物料名称',
          type: 'input',
          decorator: ['materialName'],
          attrs: {
            placeholder: '请输入'
          }
        },
        {
          label: '是否仓库卸货',
          type: 'dischargeIs'
        },
        {
          label: '调度员',
          type: 'dispatcherNo'
        },
        {
          label: '是否早班送货',
          type: 'earlyMorningDeliveryIs'
        },
        {
          label: '计划单来源',
          type: 'momAutoCreateIs'
        },
        {
          label: '采购员',
          type: 'input',
          decorator: ['purchaseUserName'],
          attrs: {
            placeholder: '请输入'
          }
        },
        { label: '创建日期', type: 'dataCreateTime' }
      ],
      formData: {
        unArrangeQuantity: {
          value: null,
          type: 'eq'
        },
        status: null
      },
      dispatcherList: []
    }
  },
  methods: {
    handleSearch (items) {
      if (items) {
        if (items['requireDeliveryDay'] && items['requireDeliveryDay'].length > 0) {
          items.requireDeliveryTimeStart = this.momentFun(items['requireDeliveryDay'][0], 'YYYY-MM-DD 00:00:00')
          items.requireDeliveryTimeEnd = this.momentFun(items['requireDeliveryDay'][1], 'YYYY-MM-DD 23:59:59')
        } else {
          delete items.requireDeliveryTimeStart
          delete items.requireDeliveryTimeEnd
        }
        delete items.requireDeliveryDay
        if (items['dataCreateTime'] && items['dataCreateTime'].length > 0) {
          items.dataCreateTimeStart = this.momentFun(items['dataCreateTime'][0], 'YYYY-MM-DD 00:00:00')
          items.dataCreateTimeEnd = this.momentFun(items['dataCreateTime'][1], 'YYYY-MM-DD 23:59:59')
        } else {
          delete items.dataCreateTimeStart
          delete items.dataCreateTimeEnd
        }
        delete items.dataCreateTime
        delete items.searchFormLabel
        this.$emit('onSearch', { ...items, unArrangeQuantity: this.formData.unArrangeQuantity.value !== null ? this.formData.unArrangeQuantity : undefined, status: this.formData.status })
      } else {
        this.$emit('onSearch', this.formData)
      }
    },
    reset () {
      this.formData = {
        unArrangeQuantity: {
          value: null,
          type: 'eq'
        },
        status: undefined
      }
    },
    // 手动输入
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().trim().indexOf(input.toLowerCase().trim()) >= 0
    },
    // 处理切换tab要清空单据状态的场景
    setFormDatastatus (val) {
      this.formData.status = val
    },
    // 获取调度组成员列表
    getDispatchList () {
      apiGetDispatchList().then(res => {
        if (res.code === 200) {
          this.dispatcherList = res.rows.map(item => {
            return {
              ...item,
              dispatcher: `${item.jobNo}-${item.realName}`
            }
          })
        }
      })
    },
    //
    setFormValue(value) {
      this.$refs.searchForm.form.setFieldsValue(value)
    }
  },
  mounted() {
    this.getDispatchList()
  }
}
</script>

<style scoped></style>
